import {
    useEffect, useState
} from 'react';
import {
    Card, CardContent, CardDescription, CardHeader, CardTitle
} from 'shared/components/ui/card';
import {
    secretKeysService
} from 'shared/api';
import {
    useParams
} from 'react-router-dom';
import {
    AppLoader
} from 'shared/components/LoaderSpinner';
import {
    Label
} from 'shared/components/ui/label';
import {
    Alert,
    AlertDescription
} from 'shared/components/ui/alert';
import {
    Badge
} from 'shared/components/ui/badge';
import ConfigFieldsDisplay from './config-fields-display';

const fields = [{
    label: 'Api Key',
    value: 'elasticsearchApiKey',
    copyable: true,
    type: 'masked',
}, {
    label: 'Elasticsearch Cloud Id',
    value: 'elasticsearchCloudId',
    copyable: true,
}, {
    label: 'Elasticsearch Endpoint',
    value: 'elasticsearchEndpoint',
    copyable: true,
}];

export default function ElasticsearchConfig() {
    const [secretKeys, setSecretKeys] = useState({});
    const [loading, setLoading] = useState(true);
    const [isDeploying, setIsDeploying] = useState(false);
    const [error, setError] = useState(null);

    const {
        oragID
    } = useParams();

    const getEsKeys = async () => {
        secretKeysService.getConfigDetails(oragID, 'elasticsearch')
            .then((res) => {
                if (res.data.isDeploying) {
                    setIsDeploying(true);
                } else {
                    setIsDeploying(false);
                    setSecretKeys(res.data.elasticsearch);
                }
            }).catch(error => {

                setError(error?.response?.message || 'Something went wrong');
            }).finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        getEsKeys();
    }, []);

    useEffect(() => {
        let timeoutId;

        const checkStatus = async () => {
            if (isDeploying) {
                const res = await checkDeploymentStatus();
                if (res) {
                    getEsKeys();
                } else {
                    timeoutId = setTimeout(checkStatus, 5000); // Wait 5 seconds before next check
                }
            }
        };

        checkStatus(); // Start the status check

        return () => clearTimeout(timeoutId); // Clear timeout on cleanup
    }, [isDeploying]);

    const checkDeploymentStatus = async () => {
        try {
            const response = await secretKeysService.checkElasticsearchDeployment(oragID);
            if (response.status === 202) {
                return false;
            } else {
                return true;
            }
        } catch (error) {
            console.error('Error checking deployment status:', error);
            return false;
        }
    };

    if (loading) {
        return <div className='flex flex-grow flex-col justify-center items-center'> <AppLoader size={50} /> </div>;
    }

    if (error) {
        return <h1> Error: {error} </h1>;
    }

    return (
        <OrganizationKeyCard
            esKeys={secretKeys}
        />
    );
}

const OrganizationKeyCard = ({
    esKeys
}) => {
    return (
        <Card>
            <CardHeader>
                <CardTitle>Elasticsearch Keys</CardTitle>
                <CardDescription>Manage your organization's configuration keys</CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
                <div className="space-y-3">
                    <div className="space-y-2">
                        <Label htmlFor={'db-store-type'}> Elasticsearch Store Type: </Label>
                        <Badge variant="outline" className="text-sm">{esKeys.keyType || 'Not Active'}</Badge>
                    </div>
                </div>

                {esKeys.keyType === 'dedicated' ? (
                    <div className="space-y-3">
                        {fields.length > 0 ? (
                            <ConfigFieldsDisplay fields={fields.map((item) => ({
                                ...item,
                                value: esKeys[item.value] || ''
                            }))} />
                        ) : (
                            <div className="py-8 text-center text-muted-foreground">
                                <p>Connection guide documentation will be displayed here.</p>
                            </div>
                        )}
                    </div>
                ) : (
                    <Alert>
                        <AlertDescription>
                            Please contact our customer service for assistance with Dedicated configuration. Our team will
                            help you set up the advanced features.
                        </AlertDescription>
                    </Alert>
                )}

            </CardContent>
        </Card>
    );
};